import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { IAppDispatch, IAppState } from "./";

export const useAppDispatch = () => useDispatch<IAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<IAppState> = useSelector;
